"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
const React = __importStar(require("react"));
const utils_1 = require("../../lib/utils");
const defaultStyles = "tw-flex tw-w-full tw-box-border tw-min-h-[60px] tw-p-3 tw-resize-y tw-rounded-md tw-border tw-border-solid tw-border-neutral-100 tw-bg-transparent tw-transition-colors";
const fontStyles = "tw-text-sm tw-font-semibold tw-font-sans";
const placeHolderStyles = "placeholder:tw-font-semibold placeholder:tw-text-sm placeholder:tw-text-neutral-200 placeholder:tw-font-sans placeholder:tw-opacity-100";
const disabledStyles = "disabled:tw-cursor-not-allowed disabled:tw-opacity-50";
const focusStyles = "focus-visible:tw-ring-ring focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-border-primary-300";
const readOnlyStyles = "read-only:tw-bg-primaryDim-25 read-only:focus-visible:tw-border-neutral-100 read-only:focus:tw-border-transparent read-only:focus:tw-ring-0";
const lockedStyles = "read-only:tw-bg-primary-25 read-only:focus-visible:tw-border-neutral-100 read-only:focus:tw-border-transparent read-only:focus:tw-ring-0";
const TextArea = React.forwardRef(({ locked, readonly, placeholder = "Type here", className, ...props }, ref) => {
    return (React.createElement("textarea", { className: (0, utils_1.cn)(defaultStyles, fontStyles, placeHolderStyles, disabledStyles, focusStyles, className, {
            [lockedStyles]: locked,
            [readOnlyStyles]: readonly,
        }), placeholder: `- ${placeholder} -`, ref: ref, ...props }));
});
exports.TextArea = TextArea;
TextArea.displayName = "TextArea";
